var map = {
	"./actions/arrow-left.svg": 1522,
	"./actions/arrow-right.svg": 1524,
	"./actions/clear.svg": 1525,
	"./actions/close.svg": 1526,
	"./actions/copy-paste.svg": 1527,
	"./actions/copy.svg": 1528,
	"./actions/edit.svg": 1529,
	"./actions/follow-link.svg": 1530,
	"./actions/home.svg": 1531,
	"./actions/search.svg": 1532,
	"./activatable/2fa.svg": 1533,
	"./activatable/career-status.svg": 1534,
	"./activatable/contract-addresses.svg": 1535,
	"./activatable/dashboard.svg": 1536,
	"./activatable/default.svg": 1537,
	"./activatable/event.svg": 1538,
	"./activatable/help-center.svg": 1539,
	"./activatable/hub.svg": 1540,
	"./activatable/info.svg": 1541,
	"./activatable/languages.svg": 1542,
	"./activatable/learn.svg": 1543,
	"./activatable/log-out.svg": 1544,
	"./activatable/map.svg": 1545,
	"./activatable/marketplace.svg": 1546,
	"./activatable/metaverses.svg": 1547,
	"./activatable/my-team.svg": 1548,
	"./activatable/partnership.svg": 1549,
	"./activatable/products.svg": 1550,
	"./activatable/profile.svg": 1551,
	"./activatable/promo.svg": 1552,
	"./activatable/settings.svg": 1553,
	"./activatable/theme.svg": 1554,
	"./activatable/wallet.svg": 1555,
	"./arrows/back.svg": 1556,
	"./arrows/down-rounded.svg": 1557,
	"./arrows/down.svg": 1558,
	"./arrows/forward.svg": 1559,
	"./arrows/less-fill.svg": 1560,
	"./arrows/less.svg": 1561,
	"./arrows/more-fill.svg": 1562,
	"./arrows/more-right.svg": 1563,
	"./arrows/more.svg": 1564,
	"./arrows/right.svg": 1565,
	"./arrows/s-shapeIcon.svg": 1566,
	"./arrows/unfold-more.svg": 1567,
	"./arrows/up.svg": 1568,
	"./currency/bitopex.svg": 1569,
	"./currency/btc.svg": 1570,
	"./currency/gymnet.svg": 1571,
	"./currency/moonberg.svg": 1572,
	"./currency/pap.svg": 1573,
	"./currency/usdt.svg": 1574,
	"./currency/utility.svg": 1575,
	"./general/burger-menu.svg": 1576,
	"./general/check-blue-rounded.svg": 1577,
	"./general/check.svg": 1578,
	"./general/dark-mode.svg": 1579,
	"./general/dot.svg": 1580,
	"./general/eye-off.svg": 1581,
	"./general/eye-on.svg": 1582,
	"./general/indeterminate.svg": 1583,
	"./general/info-fill.svg": 1584,
	"./general/info.svg": 1585,
	"./general/key.svg": 1586,
	"./general/languages.svg": 1587,
	"./general/left-legs.svg": 1588,
	"./general/light-mode.svg": 1589,
	"./general/loading-animation.svg": 1590,
	"./general/lock.svg": 1591,
	"./general/magic.svg": 1592,
	"./general/minus.svg": 1593,
	"./general/notification.svg": 1594,
	"./general/plus.svg": 1595,
	"./general/refresh.svg": 1596,
	"./general/right-legs.svg": 1597,
	"./general/settings.svg": 1598,
	"./general/sound-off.svg": 1599,
	"./general/sound-on.svg": 1600,
	"./general/star.svg": 1601,
	"./general/table.svg": 1602,
	"./general/time.svg": 1603,
	"./general/tree.svg": 1604,
	"./general/wallet.svg": 1605,
	"./partners/full-size/alpaca.svg": 1606,
	"./partners/full-size/bitmart.svg": 1607,
	"./partners/full-size/bitopex.svg": 1608,
	"./partners/full-size/finstreet.svg": 1609,
	"./partners/full-size/imfx.svg": 1610,
	"./partners/full-size/ivendpay.svg": 1611,
	"./partners/full-size/lbank.svg": 1612,
	"./partners/full-size/mercuryo.svg": 1613,
	"./partners/full-size/pancake-swap.svg": 1614,
	"./partners/full-size/swapin.svg": 1615,
	"./partners/full-size/trustpilot.svg": 1616,
	"./partners/full-size/workin.svg": 1617,
	"./partners/full-size/xtcom.svg": 1618,
	"./partners/full-size/zypto.svg": 1619,
	"./project-specific/h-power-1.svg": 1620,
	"./project-specific/h-power-2.svg": 1621,
	"./project-specific/h-power-3.svg": 1622,
	"./social-media/facebook.svg": 1623,
	"./social-media/instagram.svg": 1624,
	"./social-media/linkedin-colored.svg": 1625,
	"./social-media/linkedin.svg": 1626,
	"./social-media/x.svg": 1627,
	"./social-media/youtube.svg": 1628,
	"./third-party/zendesk-messenger.svg": 1629,
	"./two-tone/active-partners.svg": 1630,
	"./two-tone/big-earn.svg": 1631,
	"./two-tone/big-easy.svg": 1632,
	"./two-tone/big-empowering-affiliates.svg": 1633,
	"./two-tone/big-globus.svg": 1634,
	"./two-tone/big-integration.svg": 1635,
	"./two-tone/big-legacy.svg": 1636,
	"./two-tone/big-magic.svg": 1637,
	"./two-tone/big-network.svg": 1638,
	"./two-tone/big-not-complete.svg": 1639,
	"./two-tone/big-notifications.svg": 1640,
	"./two-tone/big-planet.svg": 1641,
	"./two-tone/big-profitable.svg": 1642,
	"./two-tone/big-start.svg": 1643,
	"./two-tone/big-success.svg": 1644,
	"./two-tone/direct-partners.svg": 1645,
	"./two-tone/inactive-partners.svg": 1646,
	"./two-tone/income-partner.svg": 1647,
	"./two-tone/left-leg.svg": 1648,
	"./two-tone/magic.svg": 1649,
	"./two-tone/my-team.svg": 1650,
	"./two-tone/no-data.svg": 1651,
	"./two-tone/right-leg.svg": 1652,
	"./two-tone/total-income.svg": 1653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1521;